export * from './register-chargepoint-page'
